import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApproveAttendanceParameters, approveAttendance } from 'src/api/attendanceAPI';
import ApiError from 'src/api/errorHandling/ApiError';

export default function useApproveAttendance() {
  const queryClient = useQueryClient();

  return useMutation<void, ApiError, ApproveAttendanceParameters>(async parameters => {
    await approveAttendance(parameters);
    queryClient.invalidateQueries(['attendance']);
    queryClient.invalidateQueries(['SigningFormPage']);
  });
}
